import React from 'react';

const Modal = ({ show, onClose, children }) => {
  if (!show) return null;

  return (
    <div className="fixed  inset-0 z-50 flex items-center justify-center bg-black bg-opacity-95">
      <div className="bg-black border border-gray-500 rounded-lg shadow-lg p-4 relative max-w-lg w-full mx-4">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-8 text-white text-xl font-bold focus:outline-none"
        >
          &times;
        </button>
        {/* Fixed height and scrollable content */}
        <div className="h-[80vh] overflow-y-auto custom-scrollbar">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
